'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Building2 } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

export default function Slide17cSchoolValue3({ id, registerRef }: Props) {
  const cards = [
    {
      title: 'Có thể tổ chức theo phiên bản phù hợp từng trường',
      desc: 'Chương trình có thể được điều chỉnh theo phiên bản phù hợp với từng trường, từng đơn vị tổ chức, giúp linh hoạt hơn trong việc lên kế hoạch và huy động thành viên tham gia hoạt động.',
    },
    {
      title: 'Được hỗ trợ poster và nội dung tuyển sinh viên tham gia',
      desc: 'Được hỗ trợ poster và nội dung tuyển sinh viên tham gia, tiện hỗ trợ có thể giúp viết nội dung và đăng nội dung tuyển sinh viên, nghiệm thành nhanh nanh.',
    },
    {
      title: 'Tiết kiệm thời gian xây dựng concept và kịch bản hoạt động',
      desc: 'Tiết kiệm thời gian xây dựng concept và kịch bản hoạt động, hoạt động xây dựng mình khi về dẫn đồng hợp, kịch bản hoạt động.',
    },
    {
      title: 'Tăng hình ảnh tích cực về trách nhiệm xã hội và lối sống xanh',
      desc: 'Tăng hình ảnh tích cực về trách nhiệm xã hội và lối sống xanh, thúc với các chứng mẹ thải dụng, ngàn lần xanh trường bản ảnh.',
    },
  ];

  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#f5f0e8]">
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-20 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-3">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[rgba(26,74,42,0.1)] border border-[rgba(26,74,42,0.2)] mb-4">
            <Building2 size={12} className="text-[#1a4a2a]" />
            <span className="text-[11px] font-700 uppercase tracking-widest text-[#1a4a2a] font-body">Dành cho nhà trường / Đoàn – Hội</span>
          </div>
          <h2 className="font-display font-800 text-[clamp(26px,4vw,52px)] leading-[1.1] text-[#1a4a2a] tracking-tight">
            Quyền lợi dành cho nhà trường / Đoàn – Hội
          </h2>
        </div>

        <div className="fade-in-up mb-10">
          <div className="w-[60px] h-[3px] bg-[#1a4a2a] rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 fade-in-up">
          {cards.map((card, i) => (
            <div
              key={`school17c-${i}`}
              className="rounded-2xl bg-[rgba(200,220,200,0.45)] border border-[rgba(26,74,42,0.2)] p-7 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
            >
              <h3 className="font-display font-700 text-[17px] text-[#1a4a2a] mb-3 leading-snug">{card.title}</h3>
              <p className="font-body text-[14px] text-[#3a5a3a] leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </SlideWrapper>
  );
}
